import React from "react";
import Category from "./Category";
import NewPost from "./RecentBlogs";
import Tag from "./Tag";
import { SOCIAL_LINKS } from "../../constants/ContactsConstant";
import { Link, useParams } from "react-router-dom";
import { BLOGS } from "../../constants/BlogConstant";
import BreadCrumbs from "../../common/BreadCrumbs";
import Date from "../../common/svg/Date";
import NavigationLinks from "../../common/NavigationLinks";
import { Blog, BlogDataItem } from "../../types/CommonTypes";

const BlogDetails = () => {
  const { blogId } = useParams<{ blogId: string }>();
  const currentBlog = BLOGS.filter((item) => item.id === blogId)?.[0] || {};
  let index = BLOGS.indexOf(currentBlog);
  let prevBlog = index > 0 ? BLOGS[index - 1] : null;
  let nextBlog = index < BLOGS.length - 1 ? BLOGS[index + 1] : null;

  const bannerItem = (currentBlog.data as BlogDataItem[]).find(
    (item): item is { bannerImage: string; description: string } =>
      "bannerImage" in item
  );

  return (
    <>
      <BreadCrumbs title="Blogs" description={currentBlog.title} />

      <div className="bolog-details-area sec-mar">
        <div className="container">
          {/* Top Section */}
          {bannerItem && (
            <div className="row">
              <div className="col-lg-12">
                <div className="post-thumb magnetic-item">
                  <img
                    className="img-fluid"
                    src={bannerItem.bannerImage}
                    alt={currentBlog.title}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="row g-lg-4 gy-5">
            <div className="col-lg-8">
              <div className="blog-details-content">
                <span>{currentBlog.category}</span>
                <h2>{currentBlog.title}</h2>
                <div className="author-and-meta">
                  <div className="author-area">
                    <div className="author-img">
                      <img
                        src="https://appthing-website.s3.ap-south-1.amazonaws.com/blog-dt-author.png"
                        alt={currentBlog.title}
                      />
                    </div>
                    <div className="author-content">
                      <h6>
                        By, <span>{currentBlog.author}</span>
                      </h6>
                    </div>
                  </div>
                  <ul className="blog-meta">
                    <li>
                      <Date />
                      {currentBlog.publishedDate}
                    </li>
                  </ul>
                </div>
                {currentBlog.data?.map((article: BlogDataItem) => {
                  return (
                    <>
                      {article.title && <h3> {article.title} </h3>}
                      {article.description && <p>{article.description}</p>}
                      {article.cardData && (
                        <blockquote>
                          <p>{article.cardData}</p>
                          <div className="bolckquote-icons">
                            <img
                              className="blockquote-icon-01"
                              src="https://appthing-website.s3.ap-south-1.amazonaws.com/blockquote-icon-01.svg"
                              alt=""
                            />
                            <img
                              className="blockquote-icon-02"
                              src="https://appthing-website.s3.ap-south-1.amazonaws.com/blockquote-icon-02.svg"
                              alt=""
                            />
                          </div>
                        </blockquote>
                      )}
                      {article.images?.length && (
                        <div className="blog-details-img-group">
                          <div className="row g-4">
                            <div className="col-lg-6">
                              <div className="blog-details-img magnetic-item">
                                <img
                                  className="img-fluid"
                                  src={article.images[0]}
                                  alt={currentBlog.title}
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="row g-4">
                                {[article.images[1], article.images[2]].map(
                                  (imageUrl, index) => (
                                    <div className="col-lg-12" key={index}>
                                      <div className="blog-details-img magnetic-item">
                                        <img
                                          className="img-fluid"
                                          src={imageUrl}
                                          alt={`Blog Image ${index + 2}`}
                                        />
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
                <div className="blog-tag-and-social">
                  <div className="tag">
                    <h6>Tag:</h6>
                    <ul>
                      <li>
                        <a href="#"> {currentBlog.tag}</a>
                      </li>
                    </ul>
                  </div>
                  <div className="social">
                    <h6>Share On:</h6>
                    <ul>
                      {SOCIAL_LINKS.map(({ icon, url }) => (
                        <li key={url}>
                          <Link
                            to={url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className={icon}></i>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="widget-area">
                <Category />
                <NewPost />
                <Tag />
              </div>
            </div>
          </div>
          {/* Navigation */}
          <NavigationLinks
            prevItem={prevBlog}
            nextItem={nextBlog}
            basePath="blogs"
          />
        </div>
      </div>
    </>
  );
};

export default BlogDetails;
